import useRouter from 'common/hooks/use-router';
import useItem from 'common/hooks/useItem';
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AlertsContext from 'common/providers/alerts';
import ReasonForm from './ReasonForm';

function Reason() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem('reasons', id);

  useEffect(() => {
    if (error) {
      setAlert(error, 'danger');
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      router.navigate('/reasons');
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataReason: any) => {
      const reason = { ...dataReason };

      try {
        if (reason.id) {
          await updateItem(reason.id, reason);
        } else {
          await saveItem(reason);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : <ReasonForm onSubmit={onSubmit} reason={item} />;
}

export default Reason;
